var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"d-flex":""}},[_c('v-spacer'),(_vm.order)?_c('v-btn',{on:{"click":_vm.downloadFile}},[_c('v-icon',[_vm._v("mdi-download")]),_vm._v("Download Ordine")],1):_vm._e(),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }